export const GET_SERVER_ERRORS = 'GET_SERVER_ERRORS';
export const SERVER_ERRORS = 'SERVER_ERRORS';
